<template>
  <aside class="sidebar">
    <div class="sidebar__inner">
      <div class="sidebar__head">
        <v-dropdown
          class="sidebar__dropdown"
          is-light
          has-chevron
          is-right
          is-collapsible
        >
          <v-avatar
            :name="this.$store.getters.getUsername"
          />
          <template slot="dropdown-menu">
            <router-link
              class="sidebar__dropdown-item"
              to="/profile"
            >
              View Profile
            </router-link>
            <router-link
              class="sidebar__dropdown-item"
              to="/change-password"
            >
              Change Password
            </router-link>
            <router-link
              to="/profile2fa"
              class="sidebar__dropdown-item"
            >
              2 Step Verification
            </router-link>
            <hr>

            <template v-if="roles.length > 0">
              <h5>Switch view to</h5>
              <div
                v-for="role in roles"
                :key="role"
                :value="role"
                class="sidebar__dropdown-item"
                @click="switchRole(role)"
              >
                {{ checkRoleFullName(role) }}
                <b v-if="checkCurrentRole(role)">*</b>
              </div>
              <hr>
            </template>
            <template v-if="checkCurrentRole(constants.NATA_ROLE_CM) && committees.length > 0">
              <h5>Switch Committees</h5>
              <div
                v-for="com in committees"
                :key="com.id"
                :value="com.id"
                class="sidebar__dropdown-item"
                @click="switchCommittee(com)"
              >
                {{ com.name }}
                <b v-if="checkCurrentCommittee(com.id)">*</b>
              </div>
              <hr>
            </template>
            <v-button
              color="transparent"
              @click="logout"
            >
              <v-icon type="logout" />
              Log out
            </v-button>
          </template>
        </v-dropdown>
        <router-link to="/dashboard">
          <v-logo
            class="sidebar__logo"
            is-light
            is-landscape
          />
        </router-link>
      </div>
      <nav class="sidebar__nav sidenav">
        <v-nav-link
          v-if="checkPermission('news')"
          to="/news"
          text="News"
          is-bordered
          icon-type="ta_useful_resources"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_AR])"
          to="/facilities"
          text="Facilities/Sites"
          is-bordered
          icon-type="map-marker"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_TA, constants.NATA_ROLE_AR,constants.NATA_ROLE_LA])"
          to="/jobs"
          text="Jobs"
          is-bordered
          icon-type="briefcase"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_AR])"
          to="/invoices"
          text="Invoices"
          is-bordered
          icon-type="invoices"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_TA, constants.NATA_ROLE_AR, constants.NATA_ROLE_LA,constants.NATA_ROLE_CM])"
          to="/publications"
          text="Publications"
          is-bordered
          icon-type="publications"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_CM])"
          to="/forum"
          text="Forum"
          is-bordered
          icon-type="comments"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_CM])"
          to="/members"
          text="Members"
          is-bordered
          icon-type="members"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_CM])"
          to="/calendar"
          text="Calendar"
          is-bordered
          icon-type="calendar"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_CM])"
          to="/meeting-documents"
          text="Meeting Documents"
          is-bordered
          icon-type="document"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_ADMIN, constants.NATA_ROLE_TA_ADMIN])"
          to="/admin/outstanding-activities"
          text="Outstanding Activities"
          is-bordered
          icon-type="clock"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_ADMIN, constants.NATA_ROLE_TA_ADMIN])"
          to="/admin/notifications"
          text="Notifications"
          is-bordered
          icon-type="bell-o"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_ADMIN, constants.NATA_ROLE_TA_ADMIN])"
          to="/admin/users"
          text="All Users"
          is-bordered
          icon-type="members"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_TA_ADMIN])"
          to="/admin/reports"
          text="Reports"
          is-bordered
          icon-type="report"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_TA])"
          to="/ta-useful-resources"
          text="Useful Resources"
          is-bordered
          icon-type="ta_useful_resources"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_AR])"
          to="/ar-resources-forms"
          text="Resources and Forms"
          is-bordered
          icon-type="ta_useful_resources"
        />
        <v-nav-link
          v-if="checkPermissions([constants.NATA_ROLE_CM,constants.NATA_ROLE_AR,constants.NATA_ROLE_TA,constants.NATA_ROLE_LA])"
          to="/contact"
          text="Contact NATA"
          is-bordered
          icon-type="phone-volume"
        />
      </nav>
    </div>
  </aside>
</template>

<script>
  import switchRole from "@/common/switchRole";
  import switchCommittee from "@/common/switchCommittee";
  import Logo from "@/atoms/Logo";
  import Avatar from "@/atoms/Avatar";
  import Dropdown from "@/molecules/Dropdown";
  import NavLink from "@/molecules/NavLink";
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  import constants from "@/common/constants";
  import {mapState} from "vuex";
  import { LOGOUT } from "@/store/actions.type";
  import router from '@/router'

  export default {
    components: {
      "v-logo": Logo,
      "v-avatar": Avatar,
      "v-dropdown": Dropdown,
      "v-nav-link": NavLink,
      "v-button": Button,
      "v-icon": Icon,
    },
    created () {
    this.constants = constants;
    },
    computed: {
      roles() {
        return (localStorage.getItem('ROLE') || '').split(',').filter(Boolean);
      },
      ...mapState({
        committees: state => state.auth.committees,
        selectedCommittee: state => state.auth.selectedCommittee
      }),
    },
    methods: {
      checkRoleFullName(role) {
        const matchingRole = constants.USER_ROLES.find(r => r.name === role);
        return matchingRole ? matchingRole.fullName : role;
      },
      checkPermission(route) {
        const current_role = localStorage.getItem(constants.CURRENT_ROLE);

        if (route === 'news') {
          return [constants.NATA_ROLE_AR, constants.NATA_ROLE_TA].includes(current_role);
        }

        return false;
      },
      checkPermissions(linkPermissions) {
        const current_role = localStorage.getItem(constants.CURRENT_ROLE);
        return linkPermissions.includes(current_role);
      },
      checkCurrentRole(role) {
        return role === localStorage.getItem(constants.CURRENT_ROLE)
      },
      checkCurrentCommittee(com){
        return com === this.$store.getters.getSelectedCommittee;
      },
      logout() {
         this.$store.dispatch(LOGOUT, this.credentials).then(data => {
         }).finally( () =>{
           router.push('/');
           location.reload();
         });
      },
      switchCommittee,
      switchRole
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .sidebar {
    .st0{fill: $white}
	  .st1{fill:#F79220;}
    background: $gradient;
    color: rgba($white, 0.65);
    h5,
    hr,
    .btn--transparent {
      color: inherit;
    }
    hr {
      border-color: rgba($white, 0.65);
    }
    .btn--transparent {
      padding-left: 0;
      padding-right: 0;
    }
    &__dropdown-item {
      display: block;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      &,
      &:hover,
      &:focus {
        color: inherit;
        text-decoration: none;
      }
    }
    &:before {
      position: absolute;
      z-index: -1;
      top: 50%;
      bottom: 0;
      left: 0;
      right: 0;
      //Clip path not supported in browserprefix
      -webkit-clip-path: polygon(0 300px, 0% 100%, 100% 100%, 100% 0);
      clip-path: polygon(0 300px, 0% 100%, 100% 100%, 100% 0);
      background: $gradient;
      content: '';
    }
    &__inner {
      position: sticky;
      top: 0;
    }
    &__head {
      padding: 50px $page-gutter 10px;
      text-align: center;
      @include minpoint(tablet) {
        padding-top: 10px;
      }
    }
    &__dropdown {
      width: 100%;
      @include minpoint(tablet) {
        display: none;
      }
    }
    &__logo {
      display: none;
      @include minpoint(tablet) {
        display: block;
        margin: -45px;
        height: 180px;
      }
    }
    @include minpoint(tablet) {
      position: relative;
      transform: translateX(0);
      box-shadow: 3px 10px 4px 0 rgba(9, 33, 57, 0.2);
    }
  }

</style>
